var _path, _rect, _rect2, _path2, _rect3, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWidgetStopwatch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 47,
    viewBox: "0 0 40 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6273 46.8732C30.4671 46.8732 39.2546 38.0857 39.2546 27.2459C39.2546 16.406 30.4671 7.61859 19.6273 7.61859C8.78744 7.61859 0 16.406 0 27.2459C0 38.0857 8.78744 46.8732 19.6273 46.8732Z",
    fill: "#37D2E9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.0049,
    y: -0.0000305176,
    width: 16.9302,
    height: 5.92558,
    rx: 2.96279,
    fill: "#733FD7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22.0098,
    y: 3.38599,
    width: 6.77209,
    height: 5.07907,
    rx: 2.53953,
    transform: "rotate(90 22.0098 3.38599)",
    fill: "#733FD7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3164 13.6437C20.3164 12.6537 21.119 11.8511 22.109 11.8511C29.5343 11.8511 35.5536 17.8705 35.5536 25.2957C35.5536 26.2858 34.751 27.0883 33.761 27.0883H20.3164V13.6437Z",
    fill: "#AFEDF6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 36.4004,
    y: 28.7814,
    width: 16.9302,
    height: 2.53953,
    rx: 1.26977,
    transform: "rotate(-180 36.4004 28.7814)",
    fill: "#733FD7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.8931,
    cy: 27.5116,
    r: 4.65581,
    fill: "#733FD7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidgetStopwatch);
export default __webpack_public_path__ + "static/media/WIDGET_STOPWATCH.a23a2056bd07c8174f074e29d6d16787.svg";
export { ForwardRef as ReactComponent };